import React from 'react'
import CardBoot from './cardBoot'
export const About = () => {
  return (
    <div className='about-section' id='about'>
      <h1 className='text-center' style={{margin:"20px"}}>About</h1>
        <CardBoot/>
        
    </div>
  )
}
